module.exports = __webpack_public_path__ + "static/media/picture6.8c98fd31.jpg";